"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tick = void 0;

var _context = require("../../context");

var _utils = require("../../utils");

var _ = require("../");

var _constants = require("../constants");

var _utils2 = require("../utils");

var Tick = (0, _context.styledWithTheme)('div')(function (_ref) {
  var selectors = _ref.theme.selectors,
      colorScheme = _ref.colorScheme,
      disabled = _ref.disabled,
      error = _ref.error;
  var isInverted = colorScheme === _.CheckboxColorScheme.Inverted;

  var getColor = function getColor(color) {
    return color === 'transparent' ? color : selectors.color(color);
  };

  var getColorParams = {
    disabled: disabled,
    error: error,
    getColor: getColor,
    isInverted: isInverted
  };
  var borderColor = (0, _utils2.getBorderColor)(getColorParams);
  var tickStrokeColor = (0, _utils2.getTickColor)(getColorParams);
  return {
    border: "".concat((0, _utils.px)(_constants.CHECKBOX_BORDER_WIDTH), " solid ").concat(borderColor),
    borderRadius: selectors.radius('R100'),
    width: (0, _utils.px)(_utils.A11Y_INLINE_MIN_SIZE),
    height: (0, _utils.px)(_utils.A11Y_INLINE_MIN_SIZE),
    boxSizing: 'border-box',
    position: 'relative',
    transition: 'border-color 0.1s, background-color 0.1s, box-shadow 0.1s',
    svg: {
      display: 'block',
      position: 'relative',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
      '.tick': {
        stroke: tickStrokeColor,
        strokeDasharray: '0, 20000',
        opacity: 0,
        transition: 'stroke-dasharray 0.1s, opacity 0.1s',
        transitionTimingFunction: 'ease-in'
      }
    }
  };
});
exports.Tick = Tick;
var _default = Tick;
exports.default = _default;